import React from 'react';
import LivenNomanation from 'assets/livenicons/liven_nomanation.svg';

import styles from './styles.module.scss';

export const LivenProud = () => {
  return (
    <div className={styles.checkoutAward}>
      <img src={LivenNomanation} alt="" />
      <div className={styles.content}>
        <h5>Loóna is proudly nominated for an</h5>
        <p>International Digital Well-being Innovation Award - 2023.</p>
      </div>
    </div>
  );
};
